import React from "react";
import { fetchUtils, Admin, Resource } from "react-admin";
import polyglotI18nProvider from 'ra-i18n-polyglot';
import ukrainianMessages from 'ra-language-ukrainian';
import authProvider from "./authProvider";
import simpleRestProvider from 'ra-data-simple-rest';
import division from './division/Index';
import provision from './provision/Index';
import legal_entity from './legal_entity/Index';
import legal_create from './legal_entity/Create';
import legal_list from './legal_entity/List';
import contract_request from './contract_request/Index';
import contract from './contract/Index';
import employee from './employee/Index';
import employee_request from './employee_request/Index';
import medication_dispense from './medication_dispense/Index';
import instructions from './instruction/Index';
import licenses from './license/Index'
import healthcare_services from './healthcare_service/Index'
import failed_prescriptions from './failed_prescription/Index'
import unprocessed_prescriptions from './unprocessed_prescriptions/Index'
import BusinessIcon from '@material-ui/icons/Business';
import HouseIcon from '@material-ui/icons/House';
import UserIcon from '@material-ui/icons/People';
import AssignmentIcon from '@material-ui/icons/Assignment';
import LoginPage from './component/LoginPage';
import MyLayout from "./component/MyLayout";
import { Cookies } from 'react-cookie';

const cookies = new Cookies(['x-session', 'mode']);
const session = cookies.get('x-session');
const mode = cookies.get('mode');

const i18nProvider = polyglotI18nProvider(() => ukrainianMessages, 'ua');
const entrypoint = process.env.REACT_APP_API_ENTRYPOINT;
const fetchJson = (url, options = {}) => {
    options.headers = new Headers({ Accept: 'application/json' });
    options.headers.set('Authorization', 'Basic ' + process.env.REACT_APP_API_TOKEN);
    options.headers.set('X-Session', localStorage.getItem('session'));
    return fetchUtils.fetchJson(url, options);
}
const dataProvider = simpleRestProvider(entrypoint, fetchJson);
let sessionAlertOpen = false;

if (session) {
    if (localStorage.getItem('session')) {
        localStorage.setItem('oldSession', localStorage.getItem('session'));
    }

    localStorage.setItem('session', session);
    localStorage.setItem('permissions', mode === 'hr' ? 'hr' : 'manager');
    localStorage.setItem('authenticated', 'true');
} else {
    localStorage.setItem('permissions', 'admin');
    localStorage.setItem('authenticated', 'true');
    //window.location = process.env.REACT_APP_BASE_ENTRYPOINT + '/logout';
}

const admin = () => {
    return (
            <Admin
                dataProvider={dataProvider}
                authProvider={authProvider}
                i18nProvider={i18nProvider}
                loginPage={LoginPage}
                layout={MyLayout}
                locale="ua"
            >
                {permissions => [
                permissions === 'admin' ? <Resource name="legal_entities" create={legal_create} options={{label: 'Юр. особи'}} /> : null,

                permissions === 'hr' ? <Resource name="legal_entities" list={legal_list} options={{label: 'Моя організація'}} icon={BusinessIcon} /> : null,
                permissions === 'hr' ? <Resource name="employees" {...employee} options={{label: 'Співробітники'}}  icon={UserIcon} /> : null,
                permissions === 'hr' ? <Resource name="employee_requests" {...employee_request} options={{label: 'Запрошення співробітників'}}  icon={UserIcon} /> : null,
                permissions === 'hr' ? <Resource name="divisions" {...division} options={{label: 'Аптеки'}} icon={HouseIcon} /> : null,
                // permissions === 'hr' ? <Resource name="instructions" {...instructions} options={{label: 'Інструкції'}}  icon={AssignmentIcon} /> : null,

                permissions === 'manager' ? <Resource name="legal_entities" {...legal_entity} options={{label: 'Моя організація'}} icon={BusinessIcon} /> : null,
                permissions === 'manager' ? <Resource name="divisions" {...division} options={{label: 'Мої аптеки'}} icon={HouseIcon} /> : null,
                permissions === 'manager' ? <Resource name="medical_program_provisions" {...provision} options={{label: 'Мед. програми'}} icon={AssignmentIcon} /> : null,
                permissions === 'manager' ? <Resource name="licenses" {...licenses} options={{label: 'Ліцензії'}} icon={AssignmentIcon} /> : null,
                permissions === 'manager' ? <Resource name="healthcare_services" {...healthcare_services} options={{label: 'Мед. послуги'}} icon={AssignmentIcon} /> : null,
                permissions === 'manager' ? <Resource name="employees" {...employee} options={{label: 'Мої співробітники'}}  icon={UserIcon} /> : null,
                permissions === 'manager' ? <Resource name="employee_requests" {...employee_request} options={{label: 'Запрошення співробітників'}}  icon={UserIcon} /> : null,
                permissions === 'manager' ? <Resource name="contract_requests" {...contract_request} options={{label: 'Мої заявки на договір'}}  icon={AssignmentIcon} /> : null,
                permissions === 'manager' ? <Resource name="contracts" {...contract} options={{label: 'Мої договори'}}  icon={AssignmentIcon} /> : null,
                permissions === 'manager' ? <Resource name="medication_dispenses" {...medication_dispense} options={{label: 'Погашення рецептів'}}  icon={AssignmentIcon} /> : null,
                permissions === 'manager' && process.env.REACT_APP_DEMO_MODE === 'off' ? <Resource name="failed_prescriptions" {...failed_prescriptions} options={{label: 'Непогашені рецепти'}}  icon={AssignmentIcon} /> : null,
                permissions === 'manager' && process.env.REACT_APP_DEMO_MODE === 'off' ? <Resource name="prescription_logs" {...unprocessed_prescriptions} options={{label: 'Необроблені рецепти'}}  icon={AssignmentIcon} /> : null,
                // permissions === 'manager' ? <Resource name="instructions" {...instructions} options={{label: 'Інструкції'}}  icon={AssignmentIcon} /> : null
                ]}

                {/*<SessionAlertDialog />*/}
            </Admin>
    );
};

export default admin;
